import { FC } from 'react';

import { Card } from '@/components/atoms';
import { CardContent } from '@/components/atoms/Card/Card';
import { EDIT_CELL_TEXT_TEST_IDS } from '@/constants/data-testids';

type EditTextCellProps = {
  title: string;
  description: string;
};

export const EditTextCell: FC<EditTextCellProps> = ({ title, description }) => {
  return (
    <div data-testid={EDIT_CELL_TEXT_TEST_IDS.WRAPPER} className="max-w-[582px] w-full">
      <div className="mb-5">
        <h2 className="text-body-20-semibold text-custom-warm-grey-800 mb-2">{title}</h2>
        <p className="text-body-14-regular text-custom-warm-grey-500">{description}</p>
      </div>

      <div className="flex items-center gap-6">
        <Card className="max-w-[385px] w-full h-[180px] rounded-[12px] shadow-edit-cell-text-chart-block">
          <CardContent />
        </Card>
        <Card className="max-w-[176px] w-full h-[180px] rounded-[12px] shadow-edit-cell-text-chart-block">
          <CardContent />
        </Card>
      </div>
    </div>
  );
};
